import React, { useContext } from 'react';
import ProfileMenuComponent from './ProfileMenuComponent';
import { useNavigate } from "react-router-dom";
import { AppContext } from '../../context/AppContext';
import { LOGOUT_ENDPOINT } from 'constant/endpoints';
import Cookies from 'js-cookie';


function ProfileMenuContainer(props) {
    const {
        isMenuOpen,
        setMenuOpen
    } = props;
    const navigate = useNavigate();
    const { api,permissions,setAccount,setIsInitialized, account, setLastUrl } = useContext(AppContext);

    function handleOnClickSettings() {
        setMenuOpen(false)
        navigate("/settings")
    }
    function handleOnClickLogout() {
        localStorage.removeItem('lastVisitedUrl')
        setMenuOpen(false)
        navigate("/logout")
    }
    function handleCloseMenu(){
        setMenuOpen(false)
    }

    function signout() {
        api(LOGOUT_ENDPOINT).then(({ ok }) => {
            if (ok) {
                setAccount(null);
                Cookies.remove("token")
                setLastUrl("");
                localStorage.removeItem('lastVisitedUrl')
                setIsInitialized(true)
                //navigate("/")
                navigate("/")
            }
        })
    }

    return (
        <ProfileMenuComponent
            isMenuOpen={isMenuOpen}
            handleOnClickSettings={handleOnClickSettings}
            handleOnClickLogout={handleOnClickLogout}
            handleCloseMenu={handleCloseMenu}
            permissions={permissions}
            signout={signout}
            account={account}
            navigate={navigate}
        />
    )
}

export default ProfileMenuContainer
